export default __webpack_public_path__ + "static/media/Screenshot 3.41ca91cc.png";